export const TRENDiIcon = () => {
  return (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 15.33C11.6 15.33 15.33 11.6 15.33 7H7V15.33Z" fill="black" />
      <path d="M26.11 7C20.91 7 16.69 11.22 16.69 16.42V31H24.31V14.62H34V7H26.11Z" fill="black" />
    </svg>
  )
}
